@if (delay === 0) {
  <footer role="contentinfo" aria-label="site Footer">
    <ds-simple-footer
      [links]="links"
      [message]="message"
      (selectedLink)="selectedLink($event)"
    ></ds-simple-footer>
  </footer>
}
